<div class="modal-body">
    @if (isLoading) {
    <rask-busy-spinner size="5" class="spinner"></rask-busy-spinner>
    }
    @else if (arbetsorderInmatningshandelssortimentData.length > 0) {
    <div class="row col-12 g-0">
        @if (tableColumns) {
        <rask-table [data]="arbetsorderInmatningshandelssortimentData"
            [columns]="tableColumns"
            [noScroll]="true">
        </rask-table>
        }
    </div>
    }
    @else {
    <div>
        Finns ingen mätningsinformation att visa för denna arbetsorder.
    </div>
    }
    <div class="modal-footer">
        <rask-button color="primary" (click)="spara()" [disabled]="!canSave()">Spara</rask-button>
        <rask-button color="secondary" (click)="close()">Stäng</rask-button>
    </div>
</div>